import React, { Fragment } from 'react'
import Button from 'portal-modules/common/components/Button'
import { Accordion } from '@entrata/portals-common/lib/components'
import DangerousInnerHTML from 'portal-modules/common/components/DangerousInnerHTML'
import PropTypes from 'prop-types'
import {
  StyledCookiesModalContentsPrivacyLink,
  StyledCookiesModalContentsText,
  StyledCookiesModalContentsDeniedButtonDiv,
  StyledCookiesModalContentsAccordianItemWrapper,
  StyledCookiesModalContentsAccordianArrowDownSm,
  StyledCookiesModalContentsAccordianTitle,
  StyledCookiesModalContentsRequireSpan,
  StyledCookiesModalContentsCheckBoxWrapper,
  StyledCookiesModalContentsAccordionDiv,
  StyledCookiesModalAccordionContents,
  StyledCookiesModalAccordionContentsDesc,
  StyledCookiesModalAccordionContentBox,
  StyledCookiesModalAccordionContentBoxPurposeSpan,
  StyledCookiesModalAccordionContentBoxWrapper,
  StyledCookiesModalAccordionContentBoxCheckboxSpan,
  StyledCookiesModalRoundedCheckBox,
} from './atoms'

const CookiesModalContents = ({
  groupState,
  setGroupState,
  handleCookiesUpdate,
  onClose,
  handlePrivacyPolicies,
}) => {
  let updatedGroupItem = [...groupState]
  const handleSubItemChange = (event, isParent) => {
    const { name, checked } = event.target
    if (isParent) {
      groupState &&
        groupState.map(({ group_items, group_id }, index) => {
          group_items &&
            Object.values(group_items)?.map(items => {
              updatedGroupItem[index]['group_items'][items?.group_item_id] =
                group_id === name ? { ...items, checked } : { ...items }
            })
        })
    } else {
      groupState &&
        groupState.map(({ group_items }, index) => {
          group_items &&
            Object.values(group_items)?.map(items => {
              updatedGroupItem[index]['group_items'][items?.group_item_id] =
                items?.group_item_name === name
                  ? { ...items, checked }
                  : { ...items }
            })
        })
    }
    setGroupState([...updatedGroupItem])
  }

  return (
    <>
      <StyledCookiesModalContentsText>
        <DangerousInnerHTML>
          {__(
            'We use several types of cookies to improve the browsing experience on our website. Select the categories below to learn more about their purpose and choose which types of cookies you want to allow. You may change your preferences at any time. You can learn more by viewing our',
          )}
        </DangerousInnerHTML>
        &nbsp;
        <StyledCookiesModalContentsPrivacyLink onClick={handlePrivacyPolicies}>
          {__('Privacy Policy')}
        </StyledCookiesModalContentsPrivacyLink>
      </StyledCookiesModalContentsText>
      <StyledCookiesModalContentsDeniedButtonDiv>
        <Button
          size='small'
          appearance='action'
          onClick={() => handleCookiesUpdate(onClose, 'reject_all')}
        >
          {__('Deny All Cookies')}
        </Button>
      </StyledCookiesModalContentsDeniedButtonDiv>
      <StyledCookiesModalContentsAccordionDiv>
        <Accordion>
          {groupState &&
            groupState?.map(groupItem => {
              return (
                <>
                  <Accordion.Item id={groupItem?.group_id}>
                    {({ contentProps, titleProps, expanded, toggle }) => {
                      const updatedContentProps = expanded
                        ? { ...contentProps, expanded }
                        : contentProps
                      return (
                        <Fragment key={groupItem?.group_id}>
                          <StyledCookiesModalContentsAccordianItemWrapper
                            className={'content-wrapper'}
                            id={'content-wrapper-' + groupItem?.group_id}
                          >
                            <span onClick={toggle}>
                              <StyledCookiesModalContentsAccordianArrowDownSm
                                size={24}
                                rotation={expanded ? 180 : 0}
                              />
                            </span>

                            <StyledCookiesModalContentsAccordianTitle
                              {...titleProps}
                            >
                              {__('{%s, 0}', [groupItem?.group_name])}
                            </StyledCookiesModalContentsAccordianTitle>
                            <StyledCookiesModalContentsCheckBoxWrapper>
                              {parseInt(groupItem?.group_id) === 1 ? (
                                <StyledCookiesModalContentsRequireSpan>
                                  {__('Required')}
                                </StyledCookiesModalContentsRequireSpan>
                              ) : (
                                <StyledCookiesModalRoundedCheckBox
                                  id={groupItem?.group_id}
                                  name={groupItem?.group_id}
                                  value={
                                    (groupItem?.group_items &&
                                      Object.values(
                                        groupItem?.group_items,
                                      )?.filter(item => !item?.checked)
                                        ?.length === 0) ||
                                    false
                                  }
                                  active={
                                    (groupItem?.group_items &&
                                      Object.values(
                                        groupItem?.group_items,
                                      )?.filter(item => !item?.checked)
                                        ?.length === 0) ||
                                    true
                                  }
                                  onChange={event =>
                                    handleSubItemChange(event, true)
                                  }
                                  isIndeterminate={
                                    groupItem?.group_items &&
                                    Object.values(
                                      groupItem?.group_items,
                                    )?.filter(item => !item?.checked)?.length >
                                      0 &&
                                    Object.values(
                                      groupItem?.group_items,
                                    )?.filter(item => !item?.checked)?.length <
                                      Object.values(groupItem?.group_items)
                                        ?.length
                                  }
                                />
                              )}
                            </StyledCookiesModalContentsCheckBoxWrapper>
                          </StyledCookiesModalContentsAccordianItemWrapper>

                          <StyledCookiesModalAccordionContents
                            {...updatedContentProps}
                          >
                            <StyledCookiesModalAccordionContentsDesc
                              className={
                                'content-description-' + groupItem?.group_id
                              }
                              is_editable={parseInt(groupItem?.group_id) === 1}
                            >
                              {__('{%s, 0}', [groupItem?.group_description])}
                            </StyledCookiesModalAccordionContentsDesc>
                            {groupItem?.group_items &&
                              Object.values(groupItem?.group_items)?.map(
                                item => {
                                  return (
                                    <>
                                      <StyledCookiesModalAccordionContentBoxWrapper
                                        key={item?.group_item_id}
                                      >
                                        <StyledCookiesModalAccordionContentBox>
                                          <div>
                                            <span>{__('Name:')}</span>
                                            <p>
                                              {__('{%s, 0}', [
                                                item?.group_item_name,
                                              ])}
                                            </p>
                                          </div>
                                          <div>
                                            <StyledCookiesModalAccordionContentBoxPurposeSpan>
                                              {__('Purpose:')}
                                            </StyledCookiesModalAccordionContentBoxPurposeSpan>
                                            <p>
                                              {__('{%s, 0}', [
                                                item?.item_description,
                                              ])}
                                            </p>
                                          </div>
                                        </StyledCookiesModalAccordionContentBox>
                                        <StyledCookiesModalAccordionContentBoxCheckboxSpan>
                                          {parseInt(groupItem?.group_id) ===
                                          1 ? (
                                            <StyledCookiesModalContentsRequireSpan>
                                              {__('Required')}
                                            </StyledCookiesModalContentsRequireSpan>
                                          ) : (
                                            <StyledCookiesModalRoundedCheckBox
                                              value={item?.checked}
                                              name={item?.group_item_name}
                                              active={item?.checked}
                                              onChange={event =>
                                                handleSubItemChange(
                                                  event,
                                                  false,
                                                )
                                              }
                                            />
                                          )}
                                        </StyledCookiesModalAccordionContentBoxCheckboxSpan>
                                      </StyledCookiesModalAccordionContentBoxWrapper>
                                    </>
                                  )
                                },
                              )}
                          </StyledCookiesModalAccordionContents>
                        </Fragment>
                      )
                    }}
                  </Accordion.Item>
                </>
              )
            })}
        </Accordion>
      </StyledCookiesModalContentsAccordionDiv>
    </>
  )
}

CookiesModalContents.propTypes = {
  groupState: PropTypes.arrayOf(PropTypes.object),
  setGroupState: PropTypes.func.isRequired,
  handleCookiesUpdate: PropTypes.func,
  handlePrivacyPolicies: PropTypes.func,
  onClose: PropTypes.func,
}

export default CookiesModalContents
